const styles = {
  root: { display: 'flex', flexDirection: 'column', maxWidth: '800px' },
  label: {
    padding: '10px',
    backgroundColor: '#0699A3',
    color: 'white',
    width: '100%'
  },
  dataColumn: { width: '40%' },
  generalDataContainer: {
    display: 'flex'
  },
  infoIcon: {
    marginLeft: '5px'
  },
  row: {
    display: 'flex',
    width: '100%',
    padding: '5px 20px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  expandCell: { width: '20px' },
  numberCell: {
    width: '120px'
  },
  functionCell: {
    width: '180px'
  },
  serviceName: { width: '350px' },
  serviceLabel: { justifyContent: 'space-between', display: 'flex' },
  noDataInfo: {
    padding: '20px'
  }
};

export default styles;
